import { MagnifyingGlassIcon } from "@heroicons/react/24/solid";
import React from "react";

export default function RecruiterOrdersTableHeader() {
  return (
    <div className="bg-white px-4 flex items-center justify-between py-4">
      <div className="relative">
        <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
          <MagnifyingGlassIcon className="h-5 w-5 text-gray-500" />
        </div>
        <input
          type="text"
          id="table-search-users"
          className="block p-2 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg w-80 bg-white hover:cursor-pointer"
          placeholder="Find order"
        />
      </div>
    </div>
  );
}
